var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.userUtils.isSignedIn() && !_vm.userUtils.inMaintenanceMode())?_c('AppBar'):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }